import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, FormSelect, Row, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { json, useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import * as Common from "../Common";
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import * as Picklist from '../Picklist';
import Select from 'react-select';
import $ from "jquery";
import ActivityLog from '../ActivityLog';
// import DynamicDropdown from '../DynamicSelector';


const Tran_data_unlock = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const [userRight, setUserRight] = useState([]);

    const [count, setCount] = useState(0);

    const [onceRun, setOnceRun] = useState(false);

    const [lockItem, setLockItem] = useState([]);

    const [lockEntry, setLockEntry] = useState([]);

    const [scrMode, setScrMode] = useState('');

    const [locationValue, setLocationValue] = useState(null);
    const [locationCode, setLocationCode] = useState('');
    const [location, setLocation] = useState('');

    const [srnoFrom, setSrnoFrom] = useState('');
    const [srnoTo, setSrnoTo] = useState('');
    const [type, setType] = useState('BK');
    const [filterTranType, setFilterTranType] = useState('A');
    const [filterTranSrno, setFilterTranSrno] = useState("");

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);

    const [unlockType, setUnlockType] = useState('P');
    const [status, setStatus] = useState('');

    var msg = [], i = 0;

    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");
    const [isMsgBoxExpireYN, setMsgBoxExpireYN] = useState(false);
    const [msgTextExpireYN, setMsgTextExpireYN] = useState("Sure Want to Expire All Unlock.");

    const [selectedItems, setSelectedItems] = useState([]);
    const [radioType, setRadioType] = useState('N');

    const [lineNum, setLineNum] = useState(0);
    const [ddUserOptions, setDdUserOptions] = useState([]);
    const [selectedUser, setSelectedUser] = useState({ value: "0", label: "Select" });
    const [expireUser, setExpireUser] = useState({ value: "0", label: "Select" });
    const [filterUser, setFilterUser] = useState({ value: "0", label: "Select" });
    const [tillDate, setTillDate] = useState(null);
    const [branchTypeDataUnlock, setBranchTypeDataUnlock] = useState('A');
    const [fromDateDataUnlock, setFromDateDataUnlock] = useState(new Date());
    const [toDateUnlock, setToDataUnlock] = useState(new Date());
    const [branchType, setBranchType] = useState('');
    const [periodSaveMode, setPeriodSaveMode] = useState("A");
    const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [showActivityLog, setShowActivityLog] = useState(false);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [compareData, setCompareData] = useState([]);

    const [filterSrnoFrom, setFilterSrnoFrom] = useState("");
    const [filterSrnoTo, setFilterSrnoTo] = useState("");
    const [dateFilterType, setDateFilterType] = useState('C');

    const [allTranType, setAllTranType] = useState([]);
    const [expireUserStatus, setExpireUserStatus] = useState("");

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setLocationValue(response);
                response != null && handleChange(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_DATA_UNLOCK'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                    Common.callApi(Common.apiDataUnlock, [sid, "getuserunlock"], result => {
                        setDdUserOptions(JSON.parse(result));
                    });
                    Common.callApi(Common.apiDataUnlock, [sid, "getalltrantype"], result => {
                        setAllTranType(JSON.parse(result));
                    })
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }


    }, [onceRun, sid, navigate]);

    const handleExpireUnlock = () => {
        setMsgBoxExpireYN(false);
        let msg = [];
        let i = 0;
        // if (expireUser.value === "0") {
        //     msg[i++] = Common.getMessage("MSG0006");
        //     msg[i++] = (expireUser.value === "0" ? " Select User." : '');
        //     setMsgText(Common.buildMessageFromArray(msg));
        //     setMsgBox(true);
        // } else {
        $(".loader").show();
        const obj = {
            expireUser: expireUser.value,
            expireUserStatus: expireUserStatus
        }
        Common.callApi(Common.apiDataUnlock, [sid, "expireuserunlock", JSON.stringify(obj)], result => {
            $(".loader").hide();
            let resp = JSON.parse(result);
            setLockItem([]);
            setMsgText(resp.msg);
            setMsgBox(true);
        });
        // }
    }
    const handleList = () => {
        let msg = [];
        let i = 0;
        if ((branchTypeDataUnlock === "O" && locationValue === null)
            || (radioType === "S" && (filterSrnoFrom === "" || filterSrnoTo === ""))
            || (radioType === "D" && (fromDateDataUnlock === null || toDateUnlock === null))
        ) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = ((branchTypeDataUnlock === "O" && locationValue === null) ? " Location." : '');
            msg[i++] = ((radioType === "S" && (filterSrnoFrom === "" || filterSrnoTo === "")) ? " From-To Srno." : '');
            msg[i++] = ((radioType === "D" && (fromDateDataUnlock === null || toDateUnlock === null)) ? " From-To Date." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            $(".loader").show();
            const obj = {
                branchType: branchTypeDataUnlock,
                filterStatus: status,
                type: 'IB',
                location: locationCode,
                fromDate: Common.dateYMD(fromDateDataUnlock),
                toDate: Common.dateYMD(toDateUnlock),
                unlockType: unlockType,
                dateFilterType: dateFilterType,
                filterSrnoFrom: filterSrnoFrom,
                filterSrnoTo: filterSrnoTo,
                radioType: radioType,
                filterUser: filterUser.value,
                filterTranType: filterTranType,
                filterTranSrno: filterTranSrno
            }
            Common.callApi(Common.apiDataUnlock, [sid, "getData", JSON.stringify(obj)], result => {
                $(".loader").hide();
                const resp = JSON.parse(result);
                setLockItem(resp);
            });
        }
    }

    const handleChange = value => {
        setLocationValue(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
        setLocation(loc[2]);
        sessionStorage.activeBranch = loc[1];
    }

    const handleStausChange = (res, status1) => {
        // let currentDate = new Date();
        $(".loader").show();
        const obj = {
            srno: res.tdu_srno,
            tran_srno: res.tdu_tran_srno,
            type: res.tdu_tran_type,
            status: status1,

            branchType: branchTypeDataUnlock,
            filterStatus: status,
            toDate: Common.dateYMD(toDateUnlock),
            location: locationCode,
            fromDate: Common.dateYMD(fromDateDataUnlock),
            toDate: Common.dateYMD(toDateUnlock),
            unlockType: res.tdu_unlock_type,

            dateFilterType: dateFilterType,
            filterSrnoFrom: filterSrnoFrom,
            filterSrnoTo: filterSrnoTo,
            radioType: radioType,
            filterUser: filterUser.value,
            filterTranType: filterTranType,
            filterTranSrno: filterTranSrno,
        }
        // unlockType: unlockType,
        Common.callApi(Common.apiDataUnlock, [sid, "updatestatus", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            setMsgText(resp.msg);
            setMsgBox(true);
            setLockItem(resp.resarray);
            $(".loader").hide();
        });
    }

    const handleAddNew = () => {
        $(".loader").show();
        if (!locationValue) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (!locationValue ? "Please select location." : '');
            $(".loader").hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            Common.callApi(Common.apiDataUnlock, [sid, "getuserunlock"], result => {
                $(".loader").hide();
                setDdUserOptions(JSON.parse(result));
            });
            // setFromDate(null);
            // setToDate(null);
            setLockEntry([]);
            setSrnoFrom("");
            setSrnoTo("");
            setTillDate(null);
            setSelectedUser({ value: 0, label: "Select" });
            setExpireUser({ value: 0, label: "Select" })
            setScrMode('A');
            setLineNum(0);
        }
    }

    const handleAdd = () => {
        if ((unlockType == 'T' && (!srnoFrom || !srnoTo)) || (unlockType === "P" && (!toDate || !fromDate))
            || selectedUser.value == "0" || !tillDate) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = ((!srnoFrom && unlockType == 'T') ? "Please enter from srno." : '');
            msg[i++] = (!srnoTo && unlockType == 'T' ? "Please enter to srno." : '');
            msg[i++] = (!fromDate && unlockType == 'P' ? "Please enter from date." : '');
            msg[i++] = (!toDate && unlockType == 'P' ? "Please enter to date." : '');
            msg[i++] = (!type ? 'Please select transaction type' : '');
            msg[i++] = (!tillDate ? 'Please enter till date' : '');
            msg[i++] = (selectedUser.value == "0" ? 'Please select user to give unlock.' : '');

            // msg[i++] = ((Common.dateYMD(filterDate) < startDate) ? 'Date should be in financial year' : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {

            const obj = {
                uniquekey: Common.getRandomString(15),
                tdud_lineno: lineNum + 1,
                tdud_from: srnoFrom,
                tdud_to: srnoTo,
                to_date: Common.dateYMD(toDate),
                fromDate: Common.dateYMD(fromDate),
                tdu_tran_type: type,
                tdu_unlock_user: selectedUser.value,
                tillDate: Common.dateYMD(tillDate),
                periodSaveMode: unlockType === "P" ? periodSaveMode : "",
                delny: 'Y',

            }
            const obj2 = {
                TabType: "Info",
                ALineNo: tranAuditTrail.length + 1,
                AType: "A",
                TLoc: locationCode,
                TType: 'DU',
                tdud_lineno: lineNum + 1,
                From_srno: srnoFrom,
                To_srno: srnoTo,
                to_date: Common.dateYMD(toDate),
                fromDate: Common.dateYMD(fromDate),
                tdu_tran_type: type,
                tdu_unlock_user: selectedUser.value,
                tillDate: Common.dateYMD(tillDate),
                periodSaveMode: unlockType === "P" ? periodSaveMode : "",
                delny: 'Y',
            }
            if (userRight.edit === "1" && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj2]);
            }
            setLockEntry(Common.arrayAddItem(lockEntry, obj));
            setCount(count + 1);
            setSrnoFrom('');
            setSrnoTo('');
            setSelectedUser({ value: "0", label: "Select" });
            setExpireUser({ value: "0", label: "Select" });
            setFromDate(new Date());
            setToDate(new Date());
            setType('BK');
        }

    }

    const handleSave = () => {
        $(".loader").show();
        const obj = {
            location: locationCode,
            lockEntry: lockEntry,
            unlockType: unlockType,
            status: status,
            branchType: branchTypeDataUnlock,
            fromDate: Common.dateYMD(fromDateDataUnlock),
            toDate: Common.dateYMD(toDateUnlock),
            filterStatus: status,

            dateFilterType: dateFilterType,
            filterSrnoFrom: filterSrnoFrom,
            filterSrnoTo: filterSrnoTo,
            radioType: radioType,
            filterUser: filterUser.value,
            filterTranType: filterTranType,
            filterTranSrno: filterTranSrno,
        }
        if (lockEntry.length < 1) {
            $(".loader").hide();
            setMsgBox(true);
            setMsgText("Please add atleast one record.");
            return;
        }
        Common.callApi(Common.apiDataUnlock, [sid, "saveEntry", JSON.stringify(obj)], result => {
            $(".loader").hide();
            let resp = JSON.parse(result);
            setLockItem(resp);
            setScrMode('');
            setLineNum(0);
            setTranAuditTrail([]);
            // setUnlockType('T');
        })



    }

    const handleBack = () => {
        setScrMode('');
    }

    const cancelData = () => {
        setScrMode('');
        setMsgBoxYN(false);
    }
    const handleExpire = () => {
        let msg = [];
        let i = 0;
        if (expireUser.value === "0") {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (expireUser.value === "0" ? " Select User." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            setMsgBoxExpireYN(true);
        }
    }
    const handleDelete = (val, srno, line, type) => {
        const itemToDelete = lockEntry.find(item => item.uniquekey === val);
        if (itemToDelete) {
            const formattedItem = {
                TabType: "Info",
                ALineNo: tranAuditTrail.length + 1,
                AType: "D",
                TLoc: locationCode,
                TType: 'DU',
                tdud_lineno: itemToDelete.tdud_lineno,
                tdud_from: itemToDelete.tdud_from,
                tdud_to: itemToDelete.tdud_to,
                to_date: itemToDelete.to_date,
                fromDate: itemToDelete.fromDate,
                tdu_tran_type: itemToDelete.tdu_tran_type,
                tdu_unlock_user: selectedUser.value,
                tillDate: itemToDelete.tillDate,
                periodSaveMode: itemToDelete.periodSaveMode,
            };
            if (userRight.edit === "1" && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, formattedItem]);
            }
            setLockEntry(Common.arrayRemoveItem(lockEntry, "uniquekey", val));
            setCount(count - 1);
        }
    }

    const handleView = (srno, type, loc, id, status) => {
        const obj = {
            srno: srno,
            type: type,
            id: id,
            status: status
        }
        setScrMode('E');
    }
    const btnActivityLog = (resp) => {
        setShowActivityLog(true);
        setLogObject({ trantype: "DU", trannumber: resp.tdu_srno, trancategory: "T", subtranno: resp.tdu_tran_srno });
    }

    const handleExport = () => {
        const obj = {
            radioType: radioType,
            location: locationCode,
            filterStatus: status,
            branchType: branchTypeDataUnlock,
            filterTranType: filterTranType,
            filterTranSrno: filterTranSrno,
            filterUser: filterUser.value,
            dateFilterType: dateFilterType,
            fromDate: Common.dateYMD(fromDateDataUnlock),
            toDate: Common.dateYMD(toDateUnlock)
        };

        Common.callDownloadApiPost1(Common.apiDataUnlock, "post", [sid, "exportReport", JSON.stringify(obj)], result => {
            // export code 
        })
    }


    return (
        <div>
            <LoginHeader />
            <Menu />

            <Container fluid>
                <Row>
                    <Col>
                        <h2>Data Unlock <span style={{ color: 'white' }}>{count}</span></h2>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                {
                    scrMode == '' ?
                        <>
                            <Row>
                                <Col className='col-6'>
                                    <Form.Group>
                                        <Row>
                                            <Col>
                                                <Form.Check checked={radioType === "N"} onChange={() => setRadioType("N")} type='radio' label="New" />
                                            </Col>&nbsp;
                                            {/* <Col> */}
                                            {/* <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" /> */}
                                            {/* </Col> */}
                                            <Col>
                                                {/* <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" /> */}
                                                <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Filter" />
                                            </Col>&nbsp;
                                            <Col>
                                                <Form.Check checked={radioType === "E"} onChange={() => setRadioType("E")} type='radio' label="Expire Unlock" />
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                </Col>
                            </Row>
                            {radioType === "E" ?
                                <>
                                    <Row>&nbsp;</Row>
                                    <Col className='col-md-4'>
                                        <Form.Group>
                                            <Form.Label>Select User <span className="colorThemeRed">*</span></Form.Label>
                                            <Select options={ddUserOptions} value={expireUser} onChange={v => setExpireUser(v)} />
                                        </Form.Group>
                                    </Col>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Label>Status</Form.Label>
                                        <FormSelect value={expireUserStatus} onChange={(e) => setExpireUserStatus(e.target.value)} required >
                                            <option value="">All</option>
                                            <option value="P">Pending</option>
                                            <option value="A">Approved</option>
                                        </FormSelect>
                                    </Col>
                                    <Row>&nbsp;</Row>
                                </> :
                                <>
                                    <Row>
                                        {
                                            radioType !== "N" &&
                                            <Col className='col-md-3 col-6'>
                                                <Form.Label>Status</Form.Label>
                                                <FormSelect value={status} onChange={(e) => setStatus(e.target.value)} required >
                                                    <option value="">All</option>
                                                    <option value="P">Pending</option>
                                                    <option value="A">Approve</option>
                                                    <option value="R">Reject</option>
                                                </FormSelect>
                                            </Col>
                                        }
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Branch Type <span className="text-danger">*</span></Form.Label>
                                                <Form.Select value={branchTypeDataUnlock} onChange={e => setBranchTypeDataUnlock(e.target.value)}
                                                    required>
                                                    <option value="A">All</option>
                                                    <option value="O">One</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        {branchTypeDataUnlock === 'O' ? <>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Branch<span className="text-danger">*</span></Form.Label>
                                                    <AsyncSelect
                                                        cacheOptions={false}
                                                        defaultOptions={false}
                                                        value={locationValue}
                                                        getOptionLabel={e => e.label + ' '}
                                                        getOptionValue={e => e.id}
                                                        loadOptions={Picklist.fetchLocationAllowedPicklist}
                                                        onInputChange={Picklist.handleInputChange}
                                                        onChange={(e) => handleChange(e)}
                                                        // disabled={locationValue != null}
                                                        isDisabled={branchDisable === "true"}
                                                    >
                                                    </AsyncSelect>
                                                </Form.Group>
                                            </Col></> : null}
                                    </Row>&nbsp;
                                    <Row>
                                        {
                                            radioType == 'D' &&
                                            <>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Tran Type</Form.Label>
                                                        <FormSelect value={filterTranType} onChange={(e) => setFilterTranType(e.target.value)} required>
                                                            <option value="A">All</option>
                                                            {
                                                                allTranType.map(item => (
                                                                    <option value={item.tfd_type}>{item.tfd_type}</option>
                                                                ))
                                                            }
                                                        </FormSelect>
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Tran Srno</Form.Label>
                                                        <Form.Control value={filterTranSrno}
                                                            onChange={(e) => Common.validateNumValue(e.target.value, setFilterTranSrno)}
                                                            placeholder='Tran Srno'

                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-4'>
                                                    <Form.Group>
                                                        <Form.Label>Select User</Form.Label>
                                                        <Select options={ddUserOptions} value={filterUser} onChange={v => setFilterUser(v)} />
                                                    </Form.Group>
                                                </Col>

                                            </>

                                        }
                                        {
                                            radioType === "N" ?
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Label>Unlock Type</Form.Label>
                                                    <FormSelect value={unlockType} onChange={(e) => setUnlockType(e.target.value)} required >
                                                        <option value="P">Period</option>
                                                        <option value="T">Transaction</option>
                                                    </FormSelect>
                                                </Col>
                                                : radioType === "D" ? <>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Label>Date Filter Type</Form.Label>
                                                        <FormSelect value={dateFilterType} onChange={(e) => setDateFilterType(e.target.value)} required >
                                                            <option value="C">Created At</option>
                                                            <option value="T">Till Date</option>
                                                            <option value="F">From-To Date</option>
                                                        </FormSelect>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>From Date<span className="colorThemeRed">*</span></Form.Label><br />
                                                            <DatePicker className="form-control"
                                                                selected={fromDateDataUnlock}
                                                                onChange={(date) => setFromDateDataUnlock(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                peekNextMonth
                                                                customInput={
                                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>To Date<span className="colorThemeRed">*</span></Form.Label><br />
                                                            <DatePicker className="form-control"
                                                                selected={toDateUnlock}
                                                                onChange={(date) => setToDataUnlock(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                peekNextMonth
                                                                customInput={
                                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col> </>
                                                    : radioType === "S" ?
                                                        <>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                                    <Form.Control type='text' maxLength={10} value={filterSrnoFrom} onChange={e => Common.validateNumValue(e.target.value, setFilterSrnoFrom)} />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                                    <Form.Control type='text' maxLength={10} value={filterSrnoTo} onChange={e => Common.validateNumValue(e.target.value, setFilterSrnoTo)} />
                                                                </Form.Group>
                                                            </Col>
                                                        </>
                                                        : null
                                        }

                                    </Row>&nbsp;
                                </>}

                            <Row>
                                <Col >
                                    {
                                        radioType === "N" && userRight.add === "1" ?
                                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleAddNew}>Add New</Button>
                                            : null
                                    }
                                    &nbsp;
                                    {
                                        radioType === "D" && userRight.query === "1" ?
                                            <>
                                                <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={handleList}>List</Button>
                                            </>
                                            : null
                                    }
                                    &nbsp;
                                    {
                                        radioType === "D" && userRight.query === "1" ?
                                            <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={handleExport}>Export</Button>
                                            : null
                                    }
                                    &nbsp;
                                    {
                                        radioType === "E" && userRight.delete === "1" ?
                                            <Button variant="danger" className='buttonStyle' size='sm' onClick={handleExpire}>Expire</Button>
                                            : null
                                    }
                                </Col>
                            </Row>&nbsp;
                            {
                                lockItem.length > 0 &&
                                <Row>
                                    <Col>
                                        <Table striped bordered hover size="sm">
                                            <thead>
                                                <tr>
                                                    {/* {userRight.add === "1" ? <th></th> : null} */}
                                                    <th>Srno</th>
                                                    <th>Type</th>
                                                    <th>Tran Srno</th>
                                                    <th>Location</th>
                                                    <th>Unlock Mode</th>
                                                    <th>Unlock Given To</th>
                                                    <th>Status</th>
                                                    <th>From date</th>
                                                    <th>To date</th>
                                                    <th>Till Date</th>
                                                    <th>Request</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {lockItem.map((res, index) =>
                                                    <tr key={index}>
                                                        {/* {userRight.delete === "1" ?
                                                        <td className="textCenter" >
                                                            {
                                                                <span className="handCursor"
                                                                    onClick={() => handleView(res.tdu_tran_srno, res.tdu_tran_type, res.entity_name, res.um_id, res.tdu_status)}
                                                                >
                                                                    <div className="colorThemeBlue"><FontAwesomeIcon icon={faEye} /></div>
                                                                </span>
                                                            }
                                                        </td>
                                                        : null
                                                    } */}
                                                        <td>{res.tdu_srno}</td>
                                                        <td>{res.tdu_tran_type}</td>
                                                        <td>{res.tdu_tran_srno}</td>
                                                        <td>{res.entity_name}</td>
                                                        <td>{res.tdu_unlock_mode === "E" ? "EDIT" : res.tdu_unlock_mode === "A" ? "ADD" : ""}</td>
                                                        <td>{res.um_id}</td>
                                                        <td>
                                                            {res.tdu_status === 'P' ? 'Pending' :
                                                                res.tdu_status === 'A' ? 'Approved' :
                                                                    res.tdu_status === 'R' ? 'Rejected' :
                                                                        res.tdu_status === 'E' ? 'Expired' :
                                                                            ''}
                                                        </td>
                                                        <td>{res.from_date}</td>
                                                        <td>{res.to_date}</td>
                                                        <td>{res.till_date}</td>
                                                        {res.tdu_status === 'P' && userRight.edit === "1" ?
                                                            <td>
                                                                <Button variant="primary" onClick={() => handleStausChange(res, "A")}>Approve</Button>{' '}
                                                                <Button variant="danger" onClick={() => handleStausChange(res, "R")}>Reject</Button>
                                                            </td>
                                                            : <td>&nbsp;</td>}
                                                        <td>
                                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => btnActivityLog(res)}>Activity Log</Button>&nbsp;
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                            }


                        </> : scrMode == 'A' ?
                            <>
                                <Row>
                                    <Col>
                                        <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={handleBack}>
                                            Back
                                        </Button>{' '}
                                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleSave}>
                                            Save
                                        </Button>
                                    </Col>
                                </Row>&nbsp;

                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Unlock To</Form.Label>
                                            <Select options={ddUserOptions} value={selectedUser} onChange={v => setSelectedUser(v)} />
                                        </Form.Group>
                                    </Col>
                                    {
                                        unlockType == 'T' &&
                                        <>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>From Srno<span className="colorThemeRed">*</span></Form.Label>
                                                    <Form.Control value={srnoFrom}
                                                        onChange={(e) => Common.validateNumValue(e.target.value, setSrnoFrom)}
                                                        placeholder='From Srno'

                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>To Srno<span className="colorThemeRed">*</span></Form.Label>
                                                    <Form.Control value={srnoTo}
                                                        onChange={(e) => Common.validateNumValue(e.target.value, setSrnoTo)}
                                                        placeholder='To Srno'

                                                    />
                                                </Form.Group>
                                            </Col>
                                        </>
                                    }
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Type</Form.Label>
                                            <FormSelect value={type} onChange={(e) => setType(e.target.value)} required>
                                                {/* <option value="A">All</option> */}
                                                {unlockType == 'P' && <option value="A">All</option>}
                                                {
                                                    allTranType.map(item => (
                                                        <option value={item.tfd_type}>{item.tfd_type}</option>
                                                    ))
                                                }
                                            </FormSelect>
                                        </Form.Group>
                                    </Col>
                                    {
                                        unlockType === "P" &&
                                        <>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>From Date<span className="colorThemeRed">*</span></Form.Label><br />
                                                    <DatePicker className="form-control"
                                                        selected={fromDate}
                                                        onChange={(date) => setFromDate(date)}
                                                        dateFormat="dd/MM/yyyy"
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        useShortMonthInDropdown
                                                        dropdownMode="select"
                                                        peekNextMonth
                                                        customInput={
                                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>To Date<span className="colorThemeRed">*</span></Form.Label><br />
                                                    <DatePicker className="form-control"
                                                        selected={toDate}
                                                        onChange={(date) => setToDate(date)}
                                                        dateFormat="dd/MM/yyyy"
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        useShortMonthInDropdown
                                                        dropdownMode="select"
                                                        peekNextMonth
                                                        customInput={
                                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </>
                                    }
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Till Date<span className="colorThemeRed">*</span></Form.Label><br />
                                            <DatePicker className="form-control"
                                                selected={tillDate}
                                                onChange={(date) => setTillDate(date)}
                                                dateFormat="dd/MM/yyyy"
                                                showYearDropdown
                                                showMonthDropdown
                                                useShortMonthInDropdown
                                                dropdownMode="select"
                                                peekNextMonth
                                                customInput={
                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                    {
                                        unlockType === "P" &&
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                                                <Form.Select placeholder='Mode' value={periodSaveMode} onChange={e => setPeriodSaveMode(e.target.value)} >
                                                    <option value="A">New</option>
                                                    <option value="E">Edit</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    }

                                </Row>&nbsp;

                                <Row>
                                    <Col>
                                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleAdd}>Add</Button>
                                    </Col>
                                </Row>&nbsp;

                                {
                                    lockEntry.length > 0 &&
                                    <Row>
                                        <Col>
                                            <Table striped bordered hover >
                                                <thead>
                                                    <tr>
                                                        {userRight.delete === "1" ? <th></th> : null}
                                                        <th>Type</th>
                                                        {
                                                            unlockType == 'T' ?
                                                                <>
                                                                    <th>From Srno</th>
                                                                    <th>To Srno</th>
                                                                </> : <>
                                                                    <th>Till Date</th>
                                                                </>
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {lockEntry.map((res) =>
                                                        <tr>
                                                            {userRight.delete === "1" ?
                                                                <td className="textCenter" >
                                                                    {
                                                                        (scrMode == 'E' || scrMode == 'A') && res.delny == "Y" ?
                                                                            <span className="handCursor colorThemeBlue"
                                                                                onClick={() => handleDelete(res.uniquekey, res.tdud_srno, res.tdud_line_no, res.tdu_tran_type)}>
                                                                                <FontAwesomeIcon icon={faTrash} />
                                                                            </span>
                                                                            : null
                                                                    }
                                                                </td>
                                                                : null
                                                            }
                                                            <td>{res.tdu_tran_type}</td>
                                                            {
                                                                unlockType == 'T' ?
                                                                    <>
                                                                        <td>{res.tdud_from}</td>
                                                                        <td>{res.tdud_to}</td>
                                                                    </> : <>
                                                                        <td>{res.to_date}</td>
                                                                    </>
                                                            }


                                                        </tr>
                                                    )}
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                }

                            </> : <>

                            </>
                }
            </Container>
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>

            <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                {msgTextYN}
            </DialogYesNo>
            <DialogYesNo isOpen={isMsgBoxExpireYN} onYes={(e) => handleExpireUnlock()} onNo={(e) => setMsgBoxExpireYN(false)}>
                {msgTextExpireYN}
            </DialogYesNo>

            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>

        </div>


    )
}

export default Tran_data_unlock
